import { Fragment, useEffect, useMemo, useState } from 'react';
import { Dashboard, logo_card, noData, openModalQuestion } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Input, Pagination, Tabs } from 'antd';

import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import { ICustomerFields } from '../../../api/salesSericeCustomer/salesSericeCustomerApi';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import { getWidthFromHeader, renderValueAsJSX } from '../../../until';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import StatusCellRenderer from '../../VehicleManagement/VehicleTypeManagement/Component/StatusCellRenderer';
import TabsFeilds from '../Modal/TabsFeilds';
import { TabsProps } from 'antd/lib';
import VehicleInvoiceDetail from './VehicleInvoiceDetail';
import TabTableDetail from './TabTableDetail';
dayjs.locale('vi');

const { RangePicker } = DatePicker;

const dataListFieldsByCustomerRecordActive = [
    {
        "id": 1,
        "title": "Hoá đơn xe",
        "fields": [
            {
                "id": 1,
                "fieldCode": "representative",
                "fieldLabel": "Người đại diện",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 2,
                "fieldCode": "carName",
                "fieldLabel": "Tên xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 3,
                "fieldCode": "vin",
                "fieldLabel": "Số khung (VIN)",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 4,
                "fieldCode": "licensePlate",
                "fieldLabel": "Biển số xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 5,
                "fieldCode": "color",
                "fieldLabel": "Màu xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 6,
                "fieldCode": "total",
                "fieldLabel": "Tổng tiền",
                "inputType": "number",
                "isActive": 1
            },
            {
                "id": 7,
                "fieldCode": "invoiceNumber",
                "fieldLabel": "Số hóa đơn",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 8,
                "fieldCode": "invoiceDate",
                "fieldLabel": "Ngày xuất hóa đơn",
                "inputType": "date",
                "isActive": 1
            },
            {
                "id": 9,
                "fieldCode": "buyerUnit",
                "fieldLabel": "Đơn vị mua xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 10,
                "fieldCode": "dealer",
                "fieldLabel": "Điểm bán hàng",
                "inputType": "string",
                "isActive": 1
            }
        ]


    }
]

const dataListFieldsByCustomerRecordNotActive = [
    {
        "id": 1,
        "title": "Hoá đơn xe",
        "fields": [
        ]
    }
]

const rowData = [
    {
        date: "22/02/2022",
        unit: "THACO AUTO Cần Thơ (T36)",
        salesPoint: "CN Vĩnh Long (DL) - 6501021",
        interactionType: "Khảo sát KD",
        contactType: "KH liên hệ",
        channel: "Khảo sát sự hài lòng KH-VPDH",
        contactPerson: "Tấn Tài",
        carName: "New Mazda CX-8 2.5 Luxury",
        result: "Hài lòng",
        status: "Đã đóng",
        endDate: "22/02/2022"
    },
    {
        date: "22/02/2022",
        unit: "THACO AUTO Cần Thơ (T36)",
        salesPoint: "CN Vĩnh Long (DL) - 6501021",
        interactionType: "Khảo sát DV",
        contactType: "THACO AUTO liên hệ",
        channel: "Không xác định",
        contactPerson: "",
        carName: "New Mazda CX-8 2.5 Luxury",
        result: "Hài lòng",
        status: "Đã đóng",
        endDate: "Không xác định"
    },
    {
        date: "22/02/2022",
        unit: "THACO AUTO Cần Thơ (T36)",
        salesPoint: "CN Vĩnh Long (DL) - 6501021",
        interactionType: "Khảo sát KD",
        contactType: "KH liên hệ",
        channel: "Khảo sát sự hài lòng KH-VPDH",
        contactPerson: "Tấn Tài",
        carName: "FUSO-FJ170",
        result: "Hài lòng",
        status: "Đã đóng",
        endDate: "22/02/2022"
    }
];
const columnDefs = [
    {
        headerName: "Hành động", field: "action", cellRenderer: (params: any) => {
            // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
            return (
                <div className='d-flex gap-4 justify-start align-center  h-full'>

                    <EyeOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => gInfoVehicleModel(id)}
                    />

                </div>

            )
        }
    },
    { headerName: "Ngày", field: "date" },
    { headerName: "Đơn vị", field: "unit" },
    { headerName: "Điểm bán hàng", field: "salesPoint" },
    { headerName: "Loại tương tác", field: "interactionType" },
    { headerName: "Phân loại liên hệ", field: "contactType" },
    { headerName: "Kênh tiếp nhận", field: "channel" },
    {
        headerName: "Người liên hệ", field: "contactPerson",
        cellRenderer: (params: any) => {
            return (

                params.value ? <span className="custom-page-css font-regular text-lg text-096DD9">
                    {params.value}
                </span> :

                    <span >
                        Không xác định
                    </span>


            );
        }
    },
    { headerName: "Tên xe", field: "carName" },
    { headerName: "Kết quả xử lý", field: "result" },
    { headerName: "Trạng thái kết thúc", field: "status" },
    { headerName: "Ngày kết thúc", field: "endDate" },
];



const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void, // thêm callback
): ColDef[] => {
    const baseColumns = codes
        ?.map(code => {
            const field = fields.find(f => f.fieldCode === code)
            if (!field) return null
            if (field.fieldCode === "status") {
                return {
                    headerName: field.fieldLabel,
                    field: field.fieldCode,
                    colId: field.fieldCode,
                    sortable: true,
                    cellRenderer: StatusCellRenderer,
                    cellRendererParams: {
                        onToggle: (id: number, next: boolean, rowData: any) => {
                            if (onToggleStatus) {
                                onToggleStatus(id, next, rowData)
                            }
                        },
                        idKey: 'key'
                    }
                }
            }

            return {
                headerName: field.fieldLabel,
                field: field.fieldCode,
                colId: field.fieldCode,
                sortable: true,
                width: getWidthFromHeader(field.fieldLabel),
                cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
            } as ColDef
        })
        .filter(Boolean) as ColDef[]

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
}
export default function SurveyInformation() {
    const columnDefsDetail = [
        { headerName: "Số khung (VIN)", field: "vin", minWidth: 180 },
        { headerName: "Biển số xe", field: "licensePlate", minWidth: 120 },
        { headerName: "Màu xe", field: "color", minWidth: 100 },
        { headerName: "Thương hiệu", field: "brand", minWidth: 120 },
        { headerName: "Số HĐ", field: "contract", minWidth: 200 },
        { headerName: "Tư vấn bán hàng", field: "salesConsultant", minWidth: 200 },
        { headerName: "Số Km hiện tại", field: "currentKm", minWidth: 150 },
        { headerName: "Định mức BD 1000km", field: "limitBD1000", minWidth: 180 },
        { headerName: "Ngày nhắc BD", field: "reminderDate", minWidth: 150 },
        { headerName: "Đã vào bảo dưỡng 1000", field: "maintained", minWidth: 200 },
        { headerName: "Nội dung", field: "content", minWidth: 220 },
        { headerName: "Ghi chú", field: "note", minWidth: 120 },
        {
            headerName: "Câu hỏi khảo sát", field: "surveyQuestions", minWidth: 200,
            cellRenderer: (params: any) => {
                return (
                    <div className="custom-page-css flex items-center gap-2 cursor-pointer" onClick={() => setShowModalQuestion(true)}>
                        <span className="custom-page-css font-regular text-lg text-096DD9">
                            {params.value}
                        </span>
                        <div className="custom-page-css h-6 w-6 flex items-center justify-center">
                            <img src={openModalQuestion} alt="" />
                        </div>
                    </div>

                );
            }
        }
    ];

    const rowDataDetail = [
        {
            vin: "RNH443TNART090850",
            licensePlate: "65C22983",
            color: "Trắng",
            brand: "MAZDA",
            contract: "135/2023/RNHA/TBKL-49H",
            salesConsultant: "Phạm Anh Quí (NV.23)",
            currentKm: "2.235",
            limitBD1000: "Có",
            reminderDate: "02/01/2024",
            maintained: "Không",
            content: "CHI PHÍ BẢO DƯỠNG CAO D",
            note: "Từ chối",
            surveyQuestions: "10"
        }
    ];
    const pushToast = useToast();

    const [isSettingShow, setSettingShow] = useState(false)
    const [isShowModalQuestion, setShowModalQuestion] = useState(false)

    const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
    const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

    const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

    const [demoList, setDemoList] = useState<any[]>([])
    const [rowHeight, setRowHeight] = useState(40)

    useEffect(() => {
        gListFieldsActive()
        gList()


        const handleResize = () => {
            const baseFactor = (48 * 100) / 1440 / 100
            const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
            const newHeight = Math.round(window.innerWidth * factor)
            setRowHeight(newHeight)
        }
        handleResize()

        window.addEventListener('resize', handleResize)

        return (() => {
            // setPagination({ current: 1, pageSize: 20, total: 0 })
            // setSelectedRowKeys([])
            window.removeEventListener('resize', handleResize)
        })
    }, [])


    const onChange = (key: string) => {
        // setIsTab(Number(key));
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
            children: <TabTableDetail dataRow={rowDataDetail} columnDefs={columnDefsDetail} />,
        },
    ];


    const gList = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

        setDemoList(rowData)
    }, 1000)


    const actionColumn: ColDef = {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        // width: getWidthFromHeader('Hành động'),
        cellRenderer: (params: any) => {
            // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
            return (
                <div className='d-flex gap-4 justify-start align-center  h-full'>

                    <EyeOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => gInfoVehicleModel(id)}
                    />
                    <EditOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => gInfoVehicleModel(id, false)}
                    />
                    <DeleteOutlined
                        className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => openModalDelete(Number(id))}
                    />

                </div>

            )
        },
    }


    const gListFieldsActive = async () => {
        const flattenedFields = await dataListFieldsByCustomerRecordActive.flatMap(choice =>
            choice.fields.map(field => ({
                ...field,
                parentId: choice.id,
            }))
        );
        setDataFilterActive(flattenedFields)

        gListFieldsNotActive()
    }
    const gListFieldsNotActive = async () => {
        setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive)


    }
    const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
        if (iSsuccess) {
            setSettingShow(false)
            pushToast(message, "success")
            setDataFilterActive(dataFilterActive ?? [])
            setDataFilterNoActive(dataFilterNoActive ?? [])
            gList()

        } else {
            pushToast(message, "warning")
        }
    }

    const onCloseDataFields = () => {
        setSettingShow(false)
    }

    const memoizedColumnDefs = useMemo(() => {
        return generateColumnsFromCodesAgGridReact(
            ColumnsMapShow, dataFilterActive, actionColumn,
            (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)

        );
    }, [ColumnsMapShow]);

    useEffect(() => {
        const codes = dataFilterActive.map(f => f.fieldCode)
        setColumnsMapShow(codes)
    }, [dataFilterActive])

    return (
        <Fragment>
            Đang phát triển...
        </Fragment>
    )

}
